import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

import { getBackendUrl } from '../services/origin';
const AppConfigContext = createContext({ single_tenant: false, brand_id: null, brand_name: null, loaded: false });

export const AppConfigProvider = ({ children }) => {
  const [cfg, setCfg] = useState({ single_tenant: false, brand_id: null, brand_name: null, loaded: false });

  useEffect(() => {
    const API = getBackendUrl();
    axios.get(`${API}/api/public/app-config`)
      .then(r => setCfg({ ...r.data, loaded: true }))
      .catch(() => setCfg({ single_tenant: false, brand_id: null, brand_name: null, loaded: true }));
  }, []);

  return <AppConfigContext.Provider value={cfg}>{children}</AppConfigContext.Provider>;
};

export const useAppConfig = () => useContext(AppConfigContext);
